export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-asl-534108da7a8ecc2233ff9f570b8824b2.svg";